module.exports = __webpack_public_path__ + "img/slider-02.296f29eb.jpg";